import { render } from "./BlackFlower.svg?vue&type=template&id=63e3102d"
const script = {}
script.render = render

export default script